// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__30UY2","row":"Node_row__3g_lK","label":"Node_label__2Pnjv","footer":"Node_footer__3a0sJ"};